import _ from 'lodash';
import dynamic from 'next/dynamic';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';

const Image = dynamic(import('src/components/image'));

const CardFullNav = ({ data, eventDatalayer }) => {
  if (_.isEmpty(data)) return null;
  const dateUpdate = useDateUpdate(data?.published_at);
  return (
    <CardFullNavStyle>
      <a
        href={data?.link}
        title={data.title}
        //! DATALAYER
        onClick={() =>
          sendDataLayerGlobal({
            ...eventDatalayer,
            data: {
              ...eventDatalayer.data,
              title: data?.title
            }
          })
        }
      >
        <div className='row card-nav-full'>
          <div className='thumbnail col-4'>
            <Image image={data.image} title={data.title} />
          </div>
          <div className='col-8 card-content'>
            <h3 className='text-excerpt-2'>{data.title}</h3>
            <div className='item-card-nav'>
              <span>{dateUpdate}</span>
            </div>
          </div>
        </div>
      </a>
    </CardFullNavStyle>
  );
};

const CardFullNavStyle = styled.div`
  .card-nav-full {
    margin: 10px 0;
    .card-content {
      padding: 0 15px;
      h3 {
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        transition: all 0.3s ease-in-out;
        &:hover {
          text-decoration: underline;
          text-decoration-color: #fff;
          color: var(--primary-color);
        }
      }
      .item-card-nav {
        span {
          color: #6f6f6f;
          font-size: 12px;
          font-weight: 300;
        }
      }
    }
  }
`;

export default CardFullNav;
